<template>
    <div id="nav-menu">
        <ul v-if="mobile" class="navbar-nav ml-auto p-0" id="nav">
            <li class="nav-item">
                <a aria-label="about us" class="scrollactive-item nav-link" href="#opening" @click="updateModalVisibility({})">{{ $t('מי אנחנו') }}</a>
            </li>
            <li class="nav-item">
                <a aria-label="mvp program" class="scrollactive-item nav-link" href="#mvp-offer" @click="updateModalVisibility({})">{{ $t('MVP מסובסד') }}</a>
            </li>
            <li class="nav-item">
                <a aria-label="services" class="scrollactive-item nav-link" href="#services" @click="updateModalVisibility({})">{{ $t('שירותים') }}</a>
            </li>
            <li class="nav-item">
                <a aria-label="myths-busters" class="scrollactive-item nav-link" href="#myths-busters" @click="updateModalVisibility({})">{{ $t('ניפוץ מיתוסים') }}</a>
            </li>
            <li class="nav-item">
                <a aria-label="rich-client explanation" class="scrollactive-item nav-link" href="#rich-client" @click="updateModalVisibility({})">SPA</a>
            </li>
            <li class="nav-item">
                <a aria-label="development" class="scrollactive-item nav-link" href="#falafel" @click="updateModalVisibility({})">{{ $t('על התחום') }}</a>
            </li>
            <li class="nav-item">
                <a aria-label="for tech" class="scrollactive-item nav-link" href="#tech" @click="updateModalVisibility({})">{{ $t('טכנולוגיה') }}</a>
            </li>
            <li class="nav-item">
                <a aria-label="for contact" class="scrollactive-item nav-link" href="#contact" @click="updateModalVisibility({})">{{ $t('ליצירת קשר') }}</a>
            </li>
            <li class="nav-item">
                <a aria-label="change language" class="scrollactive-item nav-link" @click="changeLang()" >{{ language === 'en' ? 'עברית' : 'English' }}</a>
            </li>
        </ul>
    </div>
</template>
<script>
    import { mapActions, mapGetters, mapState } from 'vuex';

    export default {
        name: 'mobile-nav-menu',
        computed: {
            ...mapState('layout', {
                language: state => state.language,
            }),
            ...mapGetters({
                mobile: 'layout/mobile',
                modal: 'layout/modal',
            }),
        },
        methods: {
            ...mapActions({
                updateModalVisibility: 'layout/updateModalVisibility',
                setLanguage: 'layout/setLanguage',
            }),
            changeLang() {
                this.updateModalVisibility({});
                this.setLanguage({
                    payload: {
                        language: this.language === 'en' ? 'he' : 'en',
                    },
                });
                this.$i18n.locale = this.language;
            },
        },
    }
</script>

<style lang="css" scoped>
    @media(max-width:767px) {
        .nav-item .nav-link {
            text-align: center;
            font-size: 20px;
        }
        a.scrollactive-item.nav-link {
            color: #6b696b;
        }
    }
</style>
